import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X, MapPin, ShoppingBag } from 'lucide-react';
type Notification = {
  initials: string;
  name: string;
  city: string;
  plan: 'Esencial' | 'Pro';
  time: string;
  color: string;
};
const notifications: Notification[] = [{
  initials: 'MG',
  name: 'María G.',
  city: 'Buenos Aires',
  plan: 'Pro',
  time: 'hace 2 min',
  color: 'bg-electric'
}, {
  initials: 'LP',
  name: 'Lucas P.',
  city: 'Córdoba',
  plan: 'Esencial',
  time: 'hace 4 min',
  color: 'bg-gold'
}, {
  initials: 'RM',
  name: 'Romina M.',
  city: 'Rosario',
  plan: 'Pro',
  time: 'hace 7 min',
  color: 'bg-electric'
}, {
  initials: 'JA',
  name: 'Javier A.',
  city: 'Mendoza',
  plan: 'Esencial',
  time: 'hace 9 min',
  color: 'bg-gold'
}, {
  initials: 'SC',
  name: 'Sofía C.',
  city: 'La Plata',
  plan: 'Pro',
  time: 'hace 12 min',
  color: 'bg-electric'
}, {
  initials: 'PA',
  name: 'Pablo A.',
  city: 'Tucumán',
  plan: 'Pro',
  time: 'hace 15 min',
  color: 'bg-gold'
}, {
  initials: 'VL',
  name: 'Valeria L.',
  city: 'Mar del Plata',
  plan: 'Esencial',
  time: 'hace 18 min',
  color: 'bg-electric'
}, {
  initials: 'DM',
  name: 'Diego M.',
  city: 'Salta',
  plan: 'Pro',
  time: 'hace 21 min',
  color: 'bg-gold'
}, {
  initials: 'CT',
  name: 'Camila T.',
  city: 'San Juan',
  plan: 'Esencial',
  time: 'hace 24 min',
  color: 'bg-electric'
}, {
  initials: 'FH',
  name: 'Federico H.',
  city: 'Neuquén',
  plan: 'Pro',
  time: 'hace 28 min',
  color: 'bg-gold'
}];
export function PurchaseNotifications() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    // Initial delay before first notification
    const startTimer = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(startTimer);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed || !visible) return;
    // Hide after 5s, then show next after 3s
    const hideTimer = setTimeout(() => setVisible(false), 5000);
    return () => clearTimeout(hideTimer);
  }, [index, visible, dismissed]);
  useEffect(() => {
    if (dismissed || visible) return;
    const nextTimer = setTimeout(() => {
      setIndex(i => (i + 1) % notifications.length);
      setVisible(true);
    }, 3500);
    return () => clearTimeout(nextTimer);
  }, [visible, dismissed]);
  if (dismissed) return null;
  const n = notifications[index];
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-633">
      <AnimatePresence mode="wait" data-id="element-634">
        {visible && <motion.div key={index} initial={{
        opacity: 0,
        x: -40,
        y: 10
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -40,
        y: 10
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="pointer-events-auto" data-id="element-635">
            <div className="relative bg-petroleum border border-electric/30 rounded-xl shadow-2xl shadow-black/50 p-3 pr-8 max-w-[280px] md:max-w-[320px] backdrop-blur-sm" data-id="element-636">
              {/* Folder tab */}
              <div className="absolute -top-2.5 left-3" data-id="element-637">
                <div className="bg-electric/10 border border-electric/30 rounded-t-md px-2 py-0.5" data-id="element-638">
                  <span className="text-[8px] font-mono font-bold uppercase tracking-widest text-electric" data-id="element-639">
                    Nueva Compra
                  </span>
                </div>
              </div>

              {/* Close button */}
              <button onClick={() => setDismissed(true)} aria-label="Cerrar" className="absolute top-2 right-2 w-5 h-5 rounded-full bg-white/5 hover:bg-white/15 text-textsecondary hover:text-white flex items-center justify-center transition-colors" data-id="element-640">
                <X className="w-3 h-3" strokeWidth={2.5} data-id="element-641" />
              </button>

              <div className="flex items-center gap-3 mt-1" data-id="element-642">
                {/* Avatar */}
                <div className="relative flex-shrink-0" data-id="element-643">
                  <div className={`w-10 h-10 rounded-full ${n.color} flex items-center justify-center text-graphite font-extrabold text-xs shadow-md`} data-id="element-644">
                    {n.initials}
                  </div>
                  <div className="absolute -bottom-0.5 -right-0.5 w-4 h-4 rounded-full bg-petroleum flex items-center justify-center" data-id="element-645">
                    <CheckCircle2 className="w-4 h-4 text-electric" strokeWidth={2.5} data-id="element-646" />
                  </div>
                </div>

                {/* Text */}
                <div className="flex-1 min-w-0" data-id="element-647">
                  <p className="text-xs text-white leading-snug" data-id="element-648">
                    <span className="font-bold" data-id="element-649">{n.name}</span>
                    <span className="text-textsecondary" data-id="element-650"> compró el </span>
                    <span className="font-bold text-electric" data-id="element-651">
                      SuperPack {n.plan}
                    </span>
                  </p>
                  <div className="flex items-center gap-2 mt-0.5 text-[10px] text-textsecondary font-mono" data-id="element-652">
                    <span className="flex items-center gap-0.5" data-id="element-653">
                      <MapPin className="w-2.5 h-2.5" data-id="element-654" />
                      {n.city}
                    </span>
                    <span data-id="element-655">·</span>
                    <span data-id="element-656">{n.time}</span>
                  </div>
                </div>
              </div>

              {/* Bottom accent */}
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-electric via-gold to-electric rounded-b-xl" data-id="element-657"></div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}